require('CWCookie').require('UserInfo').require('ExceptionHandler')
.define('AutomaticBlockReminder',function (imports) {
  var CWCookie = imports.CWCookie;
  var UserInfo = imports.UserInfo;
  var ExceptionHandler = imports.ExceptionHandler;
  jQuery(document).ready(function($) {
    if(!CWCookie.get_cookie("automatic_block_reminder")) {
      UserInfo.on_data_ready(ExceptionHandler.protect(function (data){
        if(data.logged_in && data.show_automatic_block_reminder) {
          $.magnificPopup.open({
              items: {
                  src: $('#cw_blocked_modal >'),
                  type: 'inline'
              }
          });
          var date = new Date();
          date.setTime(date.getTime() + (5 * 60 * 1000)); // Expire 5 minutes later
          CWCookie.set_cookie("automatic_block_reminder", "yes", { expires: date });
        }
      }));
    }
  });
});
